import { render, staticRenderFns } from "./bank-add-or-update.vue?vue&type=template&id=9e2fc63a"
import script from "./bank-add-or-update.vue?vue&type=script&lang=js"
export * from "./bank-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports